import { render, staticRenderFns } from "./CreateFromUsers.vue?vue&type=template&id=f2f901b4"
import script from "./CreateFromUsers.vue?vue&type=script&lang=js"
export * from "./CreateFromUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports